'use client';

import { NotFoundPage } from '@/components/features/layout/NotFoundPage/NotFoundPage';

export default function NotFound() {
  return (
    <NotFoundPage />
  );
}
